import { ClientInstallationStatusEnum } from '@api/enum/client-installation.enum';
import { getClientInstallationStatusCount } from '@api/services/client-installation.service';
import useDataQuery from '@hooks/use-data-query';

export const useClientInstallationStatusCount = (status: ClientInstallationStatusEnum) => {
    const clientInstallationCountQuery = useDataQuery(['client-installation-counter'], () =>
        getClientInstallationStatusCount(status)
    );

    return {
        clientInstallationCounter: clientInstallationCountQuery.data,
    };
};
